// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UpdateProjectCohortMutationVariables = Types.Exact<{
  input: Types.ProjectInput;
}>;


export type UpdateProjectCohortMutation = { __typename?: 'Mutation', saveProject: { __typename?: 'SaveProjectResult', project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } } };


export const UpdateProjectCohortDocument = gql`
    mutation UpdateProjectCohort($input: ProjectInput!) {
  saveProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export type UpdateProjectCohortMutationFn = Apollo.MutationFunction<UpdateProjectCohortMutation, UpdateProjectCohortMutationVariables>;

/**
 * __useUpdateProjectCohortMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCohortMutation, { data, loading, error }] = useUpdateProjectCohortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectCohortMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectCohortMutation, UpdateProjectCohortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectCohortMutation, UpdateProjectCohortMutationVariables>(UpdateProjectCohortDocument, options);
      }
export type UpdateProjectCohortMutationHookResult = ReturnType<typeof useUpdateProjectCohortMutation>;
export type UpdateProjectCohortMutationResult = Apollo.MutationResult<UpdateProjectCohortMutation>;
export type UpdateProjectCohortMutationOptions = Apollo.BaseMutationOptions<UpdateProjectCohortMutation, UpdateProjectCohortMutationVariables>;